import { Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';

import { SharedService } from '../../../shared/shared.service';
import { ScheduleService } from '../schedule.service';
import { environment } from '../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

//Jquery
declare var Jquery: any;
declare var $: any;

@Component({
	selector: 'app-schedule-list',
	templateUrl: './schedule-list.component.html',
	styleUrls: ['./schedule-list.component.scss']
})

export class ScheduleListComponent implements OnInit, AfterViewInit {
	//public load: boolean;
	public list: any;
	//public m_load: boolean;
	public details: any;
	public pag_size: number;
	public pag_number: number;
	public total_items: number;
	public id_schedule: string;
	private Math = Math;
	public itemQuantity = [];
	public on_button = false;
	public schedule: any = {};
	public day_helper = { 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday' };
	public userList: any;
	public schedulesList: any;
	public scheduleSuccess = [];
	public scheduleFailed = [];

	@ViewChild('contacts_pag') contacts_pag: ElementRef;
	@ViewChild('contacts_num') contacts_num: ElementRef;

	constructor(
		private _scheduleService: ScheduleService,
		private _sharedService: SharedService,
		private _router: Router,
		public toastr: ToastsManager,
		private logger: Logger,
		private spinner: NgxSpinnerService
	) {
		this.schedule.monday = [];
		this.schedule.tuesday = [];
		this.schedule.wednesday = [];
		this.schedule.thursday = [];
		this.schedule.friday = [];
		this.schedule.saturday = [];
		this.schedule.sunday = [];

		//this.load = false;
		//this.m_load = false;
		this.pag_size = 10;
		this.pag_number = 1;
	}

	ngAfterViewInit() {

		$(this.contacts_pag.nativeElement).on('change', (e) => {
			this.pag_size = e.target.value;
			this.pag_number = 1;
			this.updatePage();
		});

		$(this.contacts_num.nativeElement).on('change', (e) => {
			this.pag_number = e.target.value;
			this.updatePage();
		});

	}

	ngOnInit() {
		this.updatePage();
	}

	updatePage() {

		this.getListUsers();
		this.spinner.show();
		//this.load = true;

		let data = {
			auth_token: this._sharedService.getCookie("auth_token"),
			limit: this.pag_size, // quantity of items
			page: this.pag_number  // page
		};

		this._scheduleService.getList(data).subscribe(
			data => {

				if (data.status) { //success
					this.list = data.data.data; //data list

					this.schedulesList = data.data.data;

					this.total_items = data.data.total;
					this.itemQuantity = Array(data.data.last_page).fill(0).map((x, i) => i + 1);
					console.log('list');
					console.log(data.data.data);
				} else { // API error
					this.toastr.error(data.message, 'Error');
				}
				//this.load = false;
				this.spinner.hide();
			},
			error => { //server error
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo ', ' Error');
				this.logger.log(error);
			}
		);

	}

	getListUsers() {
		let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
		};

		this._scheduleService.getlistUser(data).subscribe(
			data => {
				console.log('lista de usuarios!!!');
				console.log(data.data.data);
				this.userList = data.data.data;
			},
			error => { // server error
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo ', ' Error');
				this.logger.log(error);
			}
		);
	}


	modalDelete(id) {

		if (id) {

			//this.load = true; // loading screen
			this.spinner.show();

			let data = {
				auth_token: this._sharedService.getCookie('auth_token'), // get cookie
				id: id
			};

			this._scheduleService.deleteSchedule(data).subscribe(
				data => {
					if (data.status) {
                        if (data.message == 'deletedFailSchedule') {
                            $('#NotDeleteSchedule').modal('toggle');
                            this.spinner.hide();
                            return;
                        }
						this.toastr.success('El Horario ha sido eliminado! ', '¡Éxito!');
						this.updatePage();
					} else {
						this.toastr.error(data.message, 'Error');
					}
					this.spinner.hide();
				},
				error => {
					this.toastr.error('Ocurrió un error, inténtalo de nuevo ', ' Error');
					this.spinner.hide();
					this.logger.log(error);
				}
			);

		}
	}

	onEdit(id: number) {
		this._router.navigate(['./admin/schedules/edit', id]);
	}

	onDetails(id: number) {

		if (!this.on_button) {
			$('#Details').modal('toggle'); // open modal

			//this.m_load = true;
			this.spinner.show();

			let data = {
				auth_token: this._sharedService.getCookie('auth_token'),
				id: id
			};

			this._scheduleService.getSchedule(data).subscribe(
				data => {
					if (data.status) {
						this.logger.log(data.data);
						this.logger.log("schedule data received");
						this.schedule.name = data.data.name

						for (let i = 0; i < data.data.schedules.length; i++) {
							let aux_day = this.day_helper[data.data.schedules[i].day_week];
							this.schedule[aux_day] = data.data.schedules[i].shift;
						}

					} else {
						this.toastr.error(data.message, 'Error');
					}
					//this.m_load = false;
					this.spinner.hide();
				},
				error => {
					this.toastr.error('Ocurrió un error, inténtalo de nuevo ', ' Error');
					//this.m_load = false;
					this.spinner.hide();
					this.logger.log(error);
				}
			);
		}
		this.on_button = false;
	}

	onDelete(id: any) {

		for (let i = 0; i < this.schedulesList.length; i++) {

			if (this.schedulesList[i].id === id) {

				for (let j = 0; j < this.userList.length; j++) {
					if (this.schedulesList[i].id !== this.userList[j].schedule_id) {

						this.scheduleFailed.push(this.userList[j].schedule_id);

					}
				}

                this.scheduleFailed = [];
                $('#DeleteSchedule').modal('toggle');
                this.id_schedule = id;
                this.on_button = true;
			}

		}

	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/schedule/schedule-list/schedule-list.component.ts